import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import DropdownSelect from 'seedly-component-library/dropdown-select';
import CheckInDate from 'components/reward/DailyCheckInRewardModal/CheckInDate';
import useIsMobile from 'utils/hooks/useIsMobile';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { useFeedCurrentPage } from 'entity/feed/feedHooks';
import { followGroupsRequest } from 'entity/group/groupRedux';
import { getFeedsRequest } from 'entity/feed/feedRedux';
import { FeedFilter } from 'entity/feed/feedTypes';
import MockDiscussionCard from './MockDiscussionCard';
import FeedList from './FeedList';

const HomeContent = () => {
  const dispatch = useDispatch();

  const filterItem: { title: string; value: FeedFilter }[] = [
    {
      title: 'Recent',
      value: 'recent',
    },
    {
      title: 'New',
      value: 'new',
    },
  ];

  const currentPage = useFeedCurrentPage();
  const isMobile = useIsMobile();
  const [selectedFilter, setSelected] = useState(filterItem[0].value);

  // get personal feeds by dropdown filter
  useEffect(() => {
    const followingGroupIds =
      JSON.parse(sessionStorage.getItem('follow_groups_upon_sign_up')) || null;
    if (followingGroupIds && followingGroupIds.length > 0) {
      dispatch(followGroupsRequest(followingGroupIds));
      sessionStorage.removeItem('follow_groups_upon_sign_up');
    } else {
      dispatch(getFeedsRequest({ feedFilter: selectedFilter, page: 1 }));
    }
  }, [dispatch, selectedFilter]);

  // load more feeds
  const handleLoadMoreFeed = useCallback(() => {
    mixpanel.track(trackedEvents.LoadMorePostClicked, {});
    dispatch(
      getFeedsRequest({ feedFilter: selectedFilter, page: currentPage + 1 }),
    );
  }, [dispatch, selectedFilter, currentPage]);

  // tracking smart feed
  useEffect(() => {
    let eventCount = 0;
    const mixpanelTracking = setInterval(() => {
      eventCount += 1;
      if (document && document.visibilityState === 'visible') {
        mixpanel.track(trackedEvents.SmartFeedDuration, {
          event_count: eventCount,
        });
      }
    }, 2000);

    return () => {
      clearInterval(mixpanelTracking);
    };
  }, []);

  return (
    <div className="flex flex-col gap-1 w-full">
      <MockDiscussionCard />
      {isMobile && <CheckInDate variant="sidebar" />}
      <DropdownSelect
        items={filterItem}
        defaultSelectedItem={filterItem[0]}
        handleSelectedItemchange={item => {
          setSelected(item.selectedItem.value);
        }}
      />
      <FeedList handleLoadMoreFeed={handleLoadMoreFeed} />
    </div>
  );
};

export default HomeContent;
